module.exports = __webpack_public_path__ + "static/media/amount.b0e28b6b.gif";